import React from "react";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import { IconLogoMini } from "../../../icons/png";
import { IconArrowRight, IconClose } from "../../../icons/svg";
import { Tinode } from "../../../tinode/tinode";
import { PACKAGE_VERSION } from "../../../version";
import Switch from "../../switch.jsx";
import { profile } from "../../../stores/storages/ProfileStorage";
import Helpers from "../../../lib/helpers";

const messages = defineMessages({
  dialog_notification_denied: {
    id: 'dialog_notification_denied',
    defaultMessage: "Please go to your browser's settings and grant notification permissions",
    description: 'Notification denied'
  },
  dialog_notification: {
    id: 'dialog_notification',
    defaultMessage: 'Notifications',
    description: 'Notifications'
  },
  button_logout: {
    id: 'button_ok',
    defaultMessage: "OK",
    description: "Button [OK]",
  }
});

class SettingHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHighPhotoQuality: profile.isHighPhotoQuality,
      notification: false,
      isSendDeliveredSeen: profile.isSendDeliveredSeen
    }
    this.handleNotification = this.handleNotification.bind(this);
    this.handleSetNotification = this.handleSetNotification.bind(this);
    this.handleActiveDeliveredSeen = this.handleActiveDeliveredSeen.bind(this);
    this.handleSetIsHighPhotoQuality = this.handleSetIsHighPhotoQuality.bind(this);
  }

  handleNotification() {
    if ('Notification' in window) {
      Notification.requestPermission().then(permission => {
        switch (permission) {
          case 'granted':
            this.handleSetNotification(!profile.notification);
            break;
          case 'denied':
            const { formatMessage } = this.props.intl;
            this.props.onShowAlert(
              formatMessage(messages.dialog_notification), // title
              formatMessage(messages.dialog_notification_denied), // content
              (_ => { }), // onConfirm
              formatMessage(messages.button_logout), // "OK"
              true, // Show Reject button
              null  // "Cancel"
            );
            this.handleSetNotification(false);
            break;

          default:
            this.handleSetNotification(false);
            break;
        }
      });
    }
  }

  handleActiveDeliveredSeen() {
    this.setState({
      isSendDeliveredSeen: !profile.isSendDeliveredSeen
    }, () => {
      profile.isSendDeliveredSeen = this.state.isSendDeliveredSeen;
      profile.save();
    })
  }

  handleSetNotification(boolean) {
    this.setState({
      notification: boolean
    }, () => {
      profile.notification = this.state.notification;
    })
  }

  handleSetIsHighPhotoQuality() {
    this.setState({
      isHighPhotoQuality: !profile.isHighPhotoQuality
    }, () => {
      profile.isHighPhotoQuality = this.state.isHighPhotoQuality;
    })
  }

  componentDidMount() {
    this.handleSetNotification(Helpers.getGrantedNotificationBrower() && profile.notification);
  }

  render() {
    return (
      <React.Fragment>
        <div className="header">
          <div className="title">
            <FormattedMessage id="dialog_titile_setting" defaultMessage={"Setting"} />
          </div>
          <div className="icon" onClick={this.props.onClose}><IconClose /></div>
        </div>
        <div className="infomation">
          <div className="logo">
            <IconLogoMini />
          </div>
          <div className="info">
            <div className="name-app">
              <FormattedMessage id="dialog_app_name" defaultMessage={"Webchat"} />
            </div>
            <div className="version">
              <FormattedMessage id="dialog_version" defaultMessage={"Version"} /> {PACKAGE_VERSION}
            </div>
          </div>
        </div>
        <div className="border-content-setting">
          <div className="gr-setting">
            <div className="name">
              <FormattedMessage id="dialog_notification" defaultMessage={"Notification"} />
            </div>
            <Switch onClick={this.handleNotification} status={this.state.notification} />
          </div>
        </div>
        <div className="border-content-setting">
          <div className="gr-setting">
            <div className="name">
              <FormattedMessage id="dialog_read_status" defaultMessage={"Show read status"} />
            </div>
            <Switch onClick={this.handleActiveDeliveredSeen} status={this.state.isSendDeliveredSeen} />
          </div>
          <div className="desc">
            <FormattedMessage id="dialog_read_the_news" defaultMessage={"Let others know you have read the news"} />
          </div>
        </div>
        <div className="border-content-setting">
          <div className="gr-setting">
            <div className="name">
              <FormattedMessage id="dialog_photo_quality" defaultMessage={"Photo quality"} />
            </div>
            <Switch onClick={this.handleSetIsHighPhotoQuality} status={this.state.isHighPhotoQuality} />
          </div>
          <div className="desc">
            <FormattedMessage id="dialog_content_photo_quality" defaultMessage={"Submit high quality photos"} />
          </div>
        </div>
        <div style={{display: 'none'}} className="border-content-setting" onClick={(_ => this.props.handleSetViewSetting(Tinode.DIALOG_SETTING_TYPE.CONVERSATION))}>
          <div className="gr-setting">
            <div className="name">
              <FormattedMessage id="dialog_hide_conversations" defaultMessage={"Hide conversations"} />
            </div>
            <div className="icon"><IconArrowRight /></div>
          </div>
        </div>
        <div className="border-content-setting" onClick={(_ => this.props.handleSetViewSetting(Tinode.DIALOG_SETTING_TYPE.SAVED_MESSAGE))}>
          <div className="gr-setting">
            <div className="name">
              <FormattedMessage id="dialog_saved_message" defaultMessage={"Saved messages"} />
            </div>
            <div className="icon"><IconArrowRight /></div>
          </div>
        </div>
        <div className="border-content-setting" onClick={(_ => this.props.handleSetViewSetting(Tinode.DIALOG_SETTING_TYPE.HIDE_TOPIC))}>
          <div className="gr-setting">
            <div className="name">
              <FormattedMessage id="dialog_hide_topic" defaultMessage={"Hidden conversations"} />
            </div>
            <div className="icon"><IconArrowRight /></div>
          </div>
        </div>
        <div className="border-content-setting" onClick={(_ => this.props.handleSetViewSetting(Tinode.DIALOG_SETTING_TYPE.LANGUAGE))}>
          <div className="gr-setting">
            <div className="name">
              <FormattedMessage id="dialog_language" defaultMessage={"Language"} />
            </div>
            <div className="icon">
              <div className="text">
                <FormattedMessage id="dialog_current_language" defaultMessage={"English"} />
              </div>
              <IconArrowRight />
            </div>
          </div>
        </div>
        <div className="border-content-setting" onClick={this.props.handleLogout}>
          <div className="gr-setting">
            <div className="name">
              <FormattedMessage id="button_logout" defaultMessage={"Logout"} />
            </div>
            <div className="icon"><IconArrowRight /></div>
          </div>
        </div>
        <div className="desc-dialog">
          <FormattedMessage id="dialog_product" defaultMessage={"A product of Viettel Media"} />
        </div>
      </React.Fragment>
    )
  }
}

export default injectIntl(SettingHome)